export default __webpack_public_path__ + "static/media/compliance.06fda2ab.png";